// extracted by mini-css-extract-plugin
export default {"button":"Button_button__cd9Mk","svg":"Button_svg__e4Fs4"};